import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

/**
 * Tracks the NBBV page view on load.
 * page_category: action_report, page_detail: list_view_{YYYYMM}, page_section: non_bonusable_bv
 */
export const nbbvPageViewTrack = (period: string) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.NBBV_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    "",
  );
};

/**
 * Tracks click on the customize KPI button (filter icon).
 * click_action: customize_KPI, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "customize_KPI",
  );
};

/**
 * Tracks cancel action in the KPI selector modal.
 * click_action: cancel_customize_KPI, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "cancel_customize_KPI",
  );
};

/**
 * Tracks apply action in the KPI selector modal.
 * click_action: apply_customize_KPI, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "apply_customize_KPI",
  );
};

/**
 * Tracks export button click.
 * click_action: export, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "export",
  );
};

/**
 * Tracks ABO profile click.
 * click_action: profile, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "profile",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 * click_action: add_to_watchlist, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 * click_action: remove_from_watchlist, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "remove_from_watchlist",
  );
};

/**
 * Tracks phone icon click.
 * click_action: phone_icon, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "phone_icon",
  );
};

/**
 * Tracks message icon click.
 * click_action: message_icon, click_category: action_report, click_detail: non_bonusable_bv
 */
export const nbbvMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.NBBV_AR,
    "message_icon",
  );
};
